//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import { setPluginIcon } from "@/assets/js/appFunc";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import SetNotifications from "@/components/Diagrams/config/set-notifications.vue";
import NotificationsPreview from "@/components/Diagrams/config/subcomponents/notifications-preview.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

const checkTimeFormat = value => {
    const regex = /^(?:\d+[d](?: {1}|$))?(?:\d+[h](?: {1}|$))?(?:\d+[m](?: {1}|$))?$/;
    return value ? regex.test(value) : !value;
};
const checkIfNumber = value => Number.isInteger(value);
// COMPONENT: DEADLINE & EXPIRATION
export default {
    components: {
        AQCheckbox,
        AQModal,
        AQInput,
        AQToggle,
        AQDropdown,
        AQChip,
        SetNotifications,
        NotificationsPreview,
        QAuModelPicker,
        AQBadge,
        AQCard
    },
    props: {
        elementIndex: {
            type: Number,
            default: 0
        },
        uuid: {
            type: String,
            default: ""
        },
        readonly: {
            type: Boolean
        },
        extraData: {
            type: Object,
            default: () => {}
        },
        value: {
            type: Object,
            default: () => {}
        },
        fromExpose: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDeadlineArea: true,
            creationDateTimeField: this.$t("diagrams.components.deadlineExpiration.defaultCreation"),
            expiratioDeadlineField: this.$t("diagrams.components.deadlineExpiration.defaultDeadline"),
            timeToDeadline: "1d",
            timeToExpiration: "0m",
            expirationTargetData: "",
            defaultCreationDateChip: "Task",
            selectedTarget: "",
            hideDeadline: ["Task.deadline"],
            modalOpened: false,
            primary: {
                label: this.$t("generic.done"),
                disabled: false
            },
            selection: [],
            showDataModel: false,
            className: "Task",
            isSystemVar: true,
            deadlineAttribute: "s_Task.creationDateTime",
            attributeName: "creationDateTime",
            enableExpiration: false,
            deadlineErrorMsg: "",
            expirationErrorMsg: "",
            deadlineNotConfigured: false,
            expirationNotConfigured: false,
            showSetNotifications: false,
            notifications: [],
            selectedNotification: null,
            fromNotif: false,
            isExposeApi: false,
            useWorkingSchedule: false,
            workScheduleExists: false
        };
    },
    validations() {
        return this.setValidations;
    },
    computed: {
        ...mapGetters("diagrams", [
            "selectedPluginConfigData",
            "diagramData",
            "diagramPlugins"
        ]),
        ...mapGetters("admin", ["roleList", "userList"]),
        selectedPluginVal() {
            let data = ""; let
                descript = "";
            if (this.value && this.value.target && this.targetDDL) {
                data = this.targetDDL.find(el => el.value === this.value.target);
            }
            if (data && data.label) {
                descript = this.$t(`diagrams.components.deadlineExpiration.${this.showDeadlineArea ? "generalInfoExp" : "generalInfoExpExpose"}`,
                    { plugin: data.label });
            }
            return descript;
        },
        getExtraDescExpiration() {
            return this.expirationTargetData && this.expirationTargetData[0] ? this.$t("diagrams.components.deadlineExpiration.processFollow",
                { plugin: this.expirationTargetData[0].label }) : "";
        },
        showPrimaryExpDesc() {
            const expirationErrors = this.$v.timeToExpiration && !this.$v.timeToExpiration.$error;
            return this.showDeadlineArea || (this.timeToExpiration && expirationErrors && this.expirationTargetData);
        },
        showGeneralExpDesc() {
            return (this.timeToExpiration && this.$v.timeToExpiration && !this.$v.timeToExpiration.$error && this.expirationTargetData);
        },
        getGeneralTitle() {
            return this.$t(`diagrams.components.deadlineExpiration.${this.showDeadlineArea ? "cardtitle" : "modalTitleExpiration"}`);
        },
        getGeneralModalTitle() {
            return this.showDeadlineArea ? this.$t("diagrams.components.deadlineExpiration.modalTitle") : this.selectedPluginConfigData.label;
        },
        getGeneralCardTitle() {
            return this.$t(`diagrams.components.deadlineExpiration.${this.showDeadlineArea ? "title" : "modalTitleExpiration"}`);
        },
        getDeadlineGeneralInfo() {
            return this.getDeadlineData(true, null, !this.showDeadlineArea, true);
        },
        getExpirationGeneralInfo() {
            return this.getDeadlineData(true, "expiration");
        },
        showExtraText() {
            return this.attributeName !== "creationDateTime";
        },
        constraint() {
            return { types: ["datetime"] };
        },
        setValidations() {
            let defaultValidations = {};
            if (this.showDeadlineArea) {
                defaultValidations = { timeToDeadline: { required, checkTimeFormat } };
                if (this.enableExpiration) {
                    const timeToExpiration = { required, checkTimeFormat };
                    const expirationTargetData = { required };
                    defaultValidations = { ...defaultValidations, timeToExpiration, expirationTargetData };
                }
            } else {
                defaultValidations = this.enableExpiration ? { timeToExpiration: { required, checkTimeFormat }, expirationTargetData: { required } } : {};
            }

            return defaultValidations;
        },
        showDescriptionDeadline() {
            return this.deadlineNotConfigured ? (this.timeToDeadline && this.$v.timeToDeadline && this.$v.timeToDeadline.checkTimeFormat) : false;
        },
        showDescripExpiration() {
            return this.expirationNotConfigured ? this.timeToExpiration && !this.$v.timeToExpiration.$error : false;
        },
        getTargetProps() {
            return {
                label: this.$t("diagrams.components.deadlineExpiration.selectTarget"),
                options: this.filterTargetDDL,
                defaultValue: this.selectedTarget,
                avatarRounded: false,
                error: this.$v.expirationTargetData && this.$v.expirationTargetData.$error,
                errorLabel: this.$t("diagrams.components.deadlineExpiration.errorTarget")
            };
        },
        checkDeadlineError() {
            return this.setErrorMsg("timeToDeadline");
        },
        checkExpirationError() {
            return this.setErrorMsg("timeToExpiration", "expiration");
        },
        targetConnectors() {
            return this.diagramData.connectors.filter(
                connector => connector.from === this.selectedPluginConfigData.uuid
            );
        },
        targetDDL() {
            const data = this.targetConnectors.map(connector => {
                const newData = {
                    label: `${
                        this.diagramData.content.filter(
                            element => element.uuid === connector.to
                        )[0].label.value
                    }`,
                    value: connector.to,
                    svgIcon: this.getTargetIcon(this.diagramData.content.filter(taskName => taskName.uuid === connector.to)[0].id)
                };
                if (this.selectedTarget && this.selectedTarget === connector.to) {
                    this.setSelectedTarget(newData);
                }
                return newData;
            });
            return data;
        },
        filterTargetDDL() {
            return this.targetDDL;
        },
        getChipType() {
            return this.isSystemVar ? "s_datamodel" : "m_datamodel";
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.setNewDataValue(newValue, true);
            },
            immediate: true
        },
        "extraData.deadline": {
            handler(newValue) {
                if (![undefined, null].includes(newValue)) {
                    this.useWorkingSchedule = !!newValue.useWorkingSchedule;
                }
                if (newValue && newValue.deadlineAttribute) {
                    this.deadlineAttribute = newValue.deadlineAttribute;
                    const [firstDeadline, secondDeadline] = this.deadlineAttribute.split(".");
                    const [isSystem, className] = firstDeadline.split("_");
                    this.attributeName = secondDeadline;
                    this.className = className;
                    this.isSystemVar = isSystem === "s";
                }
                if (!this.fromNotif) {
                    this.setNewExtraData(newValue);
                } else {
                    this.fromNotif = false;
                }
            },
            immediate: true
        },
        "extraData.notifications": {
            handler(newValue) {
                this.setNotificationsChanges(newValue);
            },
            immediate: true
        },
        selectedPluginConfigData: {
            handler(newValue) {
                if (newValue) {
                    this.showDeadlineArea = newValue.pluginType !== "EXPOSE_API_PLUGIN";
                    this.isExposeApi = newValue.pluginType === "EXPOSE_API_PLUGIN";
                    if (this.showDeadlineArea) {
                        this.expiratioDeadlineField = this.$t("diagrams.components.deadlineExpiration.defaultDeadline");
                        this.enableExpiration = !!(this.value && this.value.target);
                    } else {
                        this.expiratioDeadlineField = this.creationDateTimeField;
                        this.enableExpiration = this.isExposeApi && !!(this.value && this.value.target);
                    }
                }
            },
            immediate: true
        },
        modalOpened: {
            handler(newValue) {
                if (newValue) {
                    const connectorExists = this.targetConnectors.find(connector => connector.to === this.selectedTarget);
                    if (!connectorExists) {
                        this.enableExpiration = false;
                        this.changeData(false);
                    }
                    if (!this.userList.length) {
                        this.$store.dispatch("admin/getUsersList");
                    }
                    if (!this.roleList.length) {
                        this.$store.dispatch("admin/getRoleList");
                    }
                }
            }
        }
    },
    created() {
        this.getWorkingSchedule().then(response => {
            this.workScheduleExists = response.data;
        });
    },
    methods: {
        ...mapActions("diagrams", ["getWorkingSchedule"]),
        setPluginIcon,
        setNewDataValue(newValue, onLoad) {
            if (newValue) {
                this.enableExpiration = !!newValue.target;
                this.useWorkingSchedule = newValue.useWorkingSchedule;
                if (this.enableExpiration) {
                    this.selectedTarget = newValue.target || "";
                    if (newValue.timeUnit) {
                        this.setOldTimeFormat(newValue.expiration, newValue.timeUnit, "timeToExpiration");
                    } else {
                        this.calcExtraTime(newValue, "timeToExpiration");
                    }
                    if (onLoad) {
                        if (this.selectedTarget && !this.expirationTargetData && this.targetDDL) {
                            this.expirationTargetData = this.targetDDL.filter(el => el.value === this.selectedTarget);
                        }
                    }
                }
            } else {
                if (!this.showDeadlineArea) {
                    this.changeData(false);
                }
                this.enableExpiration = false;
            }
        },
        showDatePicker() {
            const dateTimeSelected = [];
            dateTimeSelected.push(this.className.concat(".", this.attributeName));
            this.selection = dateTimeSelected;
            this.showDataModel = true;
        },
        fieldSelection(item) {
            this.showDataModel = false;
            if (item) {
                [this.className, this.attributeName] = item[0].key.split(".");
                this.isSystemVar = item[0].formatted.split("_")[0] === "s";
                this.deadlineAttribute = item[0].formatted;
            }
            this.$refs.popoverRef.hide();
        },
        setNewExtraData(newValue) {
            if (newValue) {
                if (newValue.timeUnit) {
                    if (this.value && this.value.timeUnit) {
                        this.compareOldVersionData(newValue, this.value);
                    } else if (newValue.deadline.hasOwnProperty("deadline") && (newValue.deadline || checkIfNumber(newValue.deadline))) {
                        this.setOldTimeFormat(newValue.deadline || 0, newValue.timeUnit, "timeToDeadline");
                    } else {
                        this.timeToDeadline = "1d";
                    }
                } else {
                    const days = newValue.hasOwnProperty("days");
                    const hours = newValue.hasOwnProperty("hours");
                    const minutes = newValue.hasOwnProperty("minutes");
                    if (days || hours || minutes) {
                        this.calcExtraTime(newValue, "timeToDeadline");
                    }
                }
            } else if (this.value && this.value.timeUnit) {
                this.compareOldVersionData(newValue, this.value);
            } else {
                this.timeToDeadline = "1d";
            }
        },
        setNotificationsChanges(newValue) {
            if (newValue) {
                this.notifications = newValue;
            }
        },
        compareOldVersionData(deadlineData, expirationData) {
            const calMinutesType = (value, type) => {
                let minutesNr = 0;
                if ((value && checkIfNumber(parseInt(value, 10))) || checkIfNumber(value)) {
                    if (type === "hours") {
                        minutesNr = parseInt(value, 10) * 60;
                    } else if (type === "days") {
                        minutesNr = parseInt(value, 10) * 24 * 60;
                    } else {
                        minutesNr = parseInt(value, 10);
                    }
                }
                return minutesNr;
            };
            const deadlineDefaultVal = deadlineData && deadlineData.deadline ? deadlineData.deadline : 0;
            const deadlineDefTimeUnit = deadlineData && deadlineData.timeUnit ? deadlineData.timeUnit : "minutes";
            const deadline = calMinutesType(deadlineDefaultVal, deadlineDefTimeUnit);
            const expiration = calMinutesType(expirationData.expiration, expirationData.timeUnit);

            if (!expiration) {
                this.timeToDeadline = "0m";
                this.timeToExpiration = "0m";
            } else if (expiration <= deadline) {
                this.setOldTimeFormat(expirationData.expiration, expirationData.timeUnit, "timeToDeadline");
                this.timeToExpiration = "0m";
            } else {
                const expirationNewVal = expiration - deadline;
                this.setOldTimeFormat(expirationNewVal, "minutes", "timeToExpiration");
                this.setOldTimeFormat(deadlineDefaultVal, deadlineDefTimeUnit, "timeToDeadline");
            }
        },
        actionsDlg(event) {
            if (event === "primary") {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.checkCalcExtraTime("timeToDeadline");
                this.checkCalcExtraTime("timeToExpiration");
                this.$emit("input", this.getDataToSave());
            } else {
                this.setNewDataValue(this.value);
                this.setNewExtraData(this.extraData.deadline);
            }
            this.modalOpened = false;
        },
        changeTimeToDeadline() {
            if (this.$v.timeToDeadline) {
                this.$v.timeToDeadline.$touch();
            }
            this.checkTimeFormatValue("timeToDeadline");
        },
        changeTimeToExpiration() {
            if (this.$v.timeToExpiration) {
                this.$v.timeToExpiration.$touch();
            }
            this.checkTimeFormatValue("timeToExpiration");
        },
        checkTimeFormatValue(type) {
            setTimeout(() => {
                this.checkCalcExtraTime(type);
            }, 0);
        },
        checkCalcExtraTime(type) {
            if (this.$v[type] && this.$v[type].checkTimeFormat) {
                const data = type === "timeToExpiration" ? this.getDeadlineData(null, "expiration") : this.getDeadlineData();
                if (data.days || data.hours || data.minutes) {
                    this.calcExtraTime(data, type);
                }
            }
        },
        calcExtraTime(data, type) {
            let extraHours = 0;
            let extraDays = 0;
            const dataObject = data;
            if (dataObject.minutes && dataObject.minutes > 59) {
                let dataMinutes = 0; let
                    remainingMinutes = 0;

                dataMinutes = dataObject.minutes / 60;
                extraHours = Math.floor(dataMinutes);
                remainingMinutes = extraHours > 0 ? dataObject.minutes - (extraHours * 60) : 0;
                if (remainingMinutes > 0) {
                    dataObject.minutes = remainingMinutes;
                } else {
                    dataObject.minutes = 0;
                }
            }

            if (Number(dataObject.hours) + extraHours > 23) {
                let dataHours = 0; let
                    remainingHours = 0;
                dataObject.hours += extraHours;
                dataHours = dataObject.hours / 24;
                extraDays = Math.floor(dataHours);
                remainingHours = extraDays > 0 ? dataObject.hours - (extraDays * 24) : 0;
                if (remainingHours > 0) {
                    dataObject.hours = remainingHours;
                } else {
                    dataObject.hours = 0;
                }
            } else if (extraHours) {
                dataObject.hours = (dataObject.hours || 0) + extraHours;
            }
            if (extraDays) {
                dataObject.days = (dataObject.days || 0) + extraDays;
            }
            if ((dataObject.days || dataObject.hours) && dataObject.minutes === 0) {
                dataObject.minutes = null;
            }
            if (dataObject.days && dataObject.hours === 0) {
                dataObject.hours = null;
            }

            this[type] = this.setNewTimeFormat(dataObject);
        },
        changeData(data) {
            if (!data) {
                this.timeToExpiration = "0m";
                this.expirationTargetData = "";
                this.selectedTarget = "";
            }
        },
        setOldTimeFormat(data, timeUnit, type) {
            const newFormatData = { days: null, hours: null, minutes: null };
            newFormatData[timeUnit] = parseInt(data, 10);
            this.calcExtraTime(newFormatData, type);
        },
        setNewTimeFormat(data) {
            let newFormat = "";
            const days = ((data.days && checkIfNumber(parseInt(data.days, 10))) || checkIfNumber(data.days)) ? `${data.days}d` : "";
            const hours = ((data.hours && checkIfNumber(parseInt(data.hours, 10))) || checkIfNumber(data.hours)) ? `${data.hours}h` : "";
            const minutes = ((data.minutes && checkIfNumber(parseInt(data.minutes, 10))) || checkIfNumber(data.minutes)) ? `${data.minutes}m` : "";

            newFormat = days + (days && hours ? ` ${hours}` : hours) + (((days || hours) && minutes) ? ` ${minutes}` : minutes);
            return newFormat;
        },
        getDataToSave() {
            let deadline = null;
            let expiration = null;
            const { notifications } = this;
            const { deadlineAttribute } = this;
            for (let i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].timeFrame === "0d") {
                    this.notifications[i].timeFrame = "0;0;0";
                }
            }
            if (this.showDeadlineArea) {
                deadline = {
                    deadline: null,
                    timeUnit: null,
                    useWorkingSchedule: this.useWorkingSchedule,
                    deadlineAttribute,
                    ...this.getDeadlineData()
                };
            }
            if (this.enableExpiration) {
                expiration = {
                    expiration: null,
                    timeUnit: null,
                    target: this.expirationTargetData[0].value,
                    ...this.getDeadlineData(null, "expiration")
                };
            }
            return this.showDeadlineArea ? { deadline, expiration, notifications } : { expiration, notifications };
        },
        setSelectedTarget(data) {
            this.expirationTargetData = [data];
        },
        getTargetIcon(id) {
            return { name: this.setPluginIcon({ pluginType: id }) };
        },
        setErrorMsg(field, typeExpiration) {
            let msg = this.$t(`diagrams.components.deadlineExpiration.${typeExpiration ? "expirationError" : "deadlineError"}`);

            if (this.$v[field] && !this.$v[field].checkTimeFormat) {
                msg = this.$t("diagrams.components.deadlineExpiration.deadlineFormat");
            }
            if (typeExpiration) {
                this.expirationErrorMsg = msg;
            } else {
                this.deadlineErrorMsg = msg;
            }

            return this.$v[field].$error;
        },
        getDeadlineData(add, type, expirationOnly, generalDescrip) {
            let items = ""; let days = add ? "" : null; let hours = add ? "" : null; let minutes = add ? "" : null;
            if (!this.timeToDeadline) {
                this.timeToDeadline = "";
            }
            const splitedData = (type || expirationOnly ? this.timeToExpiration : this.timeToDeadline).split(" ");
            splitedData.forEach(element => {
                if (element.includes("d")) {
                    days = this.getDescriptInfo(element, "d", add);
                } else if (element.includes("h")) {
                    hours = this.getDescriptInfo(element, "h", add);
                } else if (element.includes("m")) {
                    minutes = this.getDescriptInfo(element, "m", add);
                }
            });
            if (add) {
                const validDays = days || checkIfNumber(days);
                const validHours = hours || checkIfNumber(hours);
                const validMinutes = minutes || checkIfNumber(minutes);

                if (validDays || validHours || validMinutes) {
                    this.checkSetNoConfig(type, expirationOnly, true);
                    const daysExist = days ? ` ${hours}` : hours;
                    const minutesExist = (days || hours) ? ` ${minutes}` : minutes;
                    const customTime = (days || "") + (hours ? daysExist : "") + (minutes ? minutesExist : "");
                    const isCustomTime = customTime ? "descriptionGen" : "description";
                    const isCustomTimeExpiration = customTime ? "descriptionExpiration1After" : "descriptionExpiration1";
                    const descriptGenTxt = generalDescrip && customTime ? "descriptionGen1" : isCustomTime;
                    items = this.$t(`diagrams.components.deadlineExpiration.${type ? isCustomTimeExpiration : descriptGenTxt}`, { customTime });
                    if (generalDescrip) {
                        items += this.$t(`diagrams.components.deadlineExpiration.${customTime ? "from" : "after"}`);
                    }
                } else {
                    this.checkSetNoConfig(type, expirationOnly);
                }
            } else {
                items = { days, hours, minutes };
            }
            return items;
        },
        checkSetNoConfig(type, expirationOnly, config) {
            if (type || expirationOnly) {
                this.expirationNotConfigured = !!config;
            } else {
                this.deadlineNotConfigured = !!config;
            }
        },
        getDescriptInfo(element, condition, add) {
            const itemNumber = parseInt(element.replace(condition, ""), 10);
            let item = Number.isNaN(itemNumber) ? "" : itemNumber;
            if (item && add) {
                item += ` ${this.$t(`diagrams.components.deadlineExpiration.${item === 1 ? condition : (`${condition}s`)}`)}`;
            }
            return item;
        },
        saveNotification(notification) {
            let found = false;
            for (let i = 0; i < this.notifications.length; i++) {
                if (this.notifications[i].id === notification.id) {
                    this.$set(this.notifications, i, notification);
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.notifications.push(notification);
            }
            this.fromNotif = true;
        },
        deleteNotification(id) {
            const indexId = this.notifications.findIndex(elem => elem.id === id);
            if (indexId > -1) {
                this.notifications.splice(indexId, 1);
            }
        }

    }
};
